<template>
  <div
    class="obituary-single__hero-deceased-image"
    :class="{
      clickable: shouldBeClickable,
      'obituary-single__hero-deceased-image--edit': isEditMode,
    }"
  >
    <!-- The portrait opens the slideshow: a real button over it, for keyboards and screen readers. -->
    <button
      class="slideshow-portrait-open"
      type="button"
      v-if="shouldBeClickable"
      :aria-label="openText"
      @click="handleImageClick"
    />
    <img
      v-if="deceasedImage"
      :alt="deceasedImage.alt"
      :src="deceasedImage.src"
      :srcset="deceasedImage.srcset"
    >
    <img
      alt="placeholder"
      src="/wp-content/assets/images/avatar.svg"
      v-else-if="isEditMode"
    >
    <div class="obituary-single__hero-deceased-image-edit" v-if="isEditMode">
      <Loader :loading="isUploadingDeceasedImage" />
      <button
        class="btn btn-white btn-sm"
        type="button"
        v-if="!isUploadingDeceasedImage"
        @click.prevent="openFilePicker"
      >
        {{ deceasedImage ? texts.changeImage : texts.addImage }}
      </button>
      <input
        accept="image/*"
        style="display: none"
        type="file"
        ref="file"
        @change="onFileChange"
      >
    </div>
  </div>
</template>

<script>
  import Loader from "Components/loader/Loader.vue";
  import { mapActions, mapMutations, mapState } from "vuex";
  import {
    hasSlideshow,
    openViewer,
    slideshowTexts,
  } from "../composables/useSlideshow";

  export default {
    components: {
      Loader,
    },
    computed: {
      ...mapState("creator", [
        "isEditMode",
        "isUploadingDeceasedImage",
        "deceasedImage",
      ]),
      shouldBeClickable() {
        return !this.isEditMode && this.hasEnoughImages;
      },
    },
    data() {
      return {
        hasEnoughImages: hasSlideshow(),
        openText: slideshowTexts().bannerOpen,
        texts: lavendlaObituary.creator,
      };
    },
    methods: {
      ...mapActions("creator", ["uploadImage"]),
      ...mapMutations("creator", ["setState"]),
      handleImageClick() {
        if (this.shouldBeClickable) {
          openViewer({ source: "portrait" });
        }
      },
      onFileChange(e) {
        const [file] = e.target.files;
        this.uploadImage({ file, type: "deceasedImage" });
      },
      openFilePicker() {
        this.$refs.file.click();
      },
    },
    name: "DeceasedImage",
  };
</script>
